import { Font, TextStyle } from 'types'
import { Row } from './Row'
import Styles from './List.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  fonts: Font[]
  textStyles?: TextStyle[]
}

export const List = ({ fonts, textStyles }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <div className={Styles.list}>
      {isSystemRedesignEnabled && (
        <Text variant="label" color="var(--dark-30)">
          Font name
        </Text>
      )}
      {fonts.map((font) => (
        <Row key={font.id} font={font} textStyles={textStyles} />
      ))}
    </div>
  )
}
